var map = {
  "./cs.messages.tsx": [
    "98765",
    [
      93723
    ]
  ],
  "./en.messages.tsx": [
    "82748",
    [
      51616
    ]
  ],
  "./sl.messages.tsx": [
    "99856",
    [
      34560
    ]
  ],
  "./hu.messages.tsx": [
    "64655",
    [
      26920
    ]
  ],
  "./de.messages.tsx": [
    "87480",
    [
      20444
    ]
  ],
  "./it.messages.tsx": [
    "27462",
    [
      80642
    ]
  ],
  "./pl.messages.tsx": [
    "99623",
    [
      11137
    ]
  ],
  "./fr.messages.tsx": [
    "78251",
    [
      13337
    ]
  ],
  "./sk.messages.tsx": [
    "14805",
    [
      48435
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 68799;
module.exports = __rspack_async_context;
